import {
    GoogleAuthProvider,
    signInWithPopup,
    onAuthStateChanged, getAuth,
} from "firebase/auth";
import {stocksEyesApp} from "./firebase";
import { useEffect, useState } from "react";

export const stocksEyesAuth = getAuth(stocksEyesApp);

export async function signInWithGoogle() {
    const provider = new GoogleAuthProvider();

    try {
        await signInWithPopup(stocksEyesAuth, provider);
    } catch (error) {
        console.error("Error signing in with Google", error);
    }
}

export async function signOut() {
    try {
        return stocksEyesAuth.signOut();
    } catch (error) {
        console.error("Error signing out with Google", error);
    }
}

export function useUser() {
    const [user, setUser] = useState();

    useEffect(() => {
        return onAuthStateChanged(stocksEyesAuth, (authUser) => {
            setUser(authUser);
            console.log(authUser)
        });
    }, []);

    return user;
}
